<template>
  <div class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="headerWrap">
          QUICK MESSAGE TO GUEST {{ selectedRoom.roomnumber }}
        </h2>
        <div class="closeMessageModalWrapper">
          <close-icon @closeEvent="close()" :dark="true"></close-icon>
        </div>
      </div>
      <div class="modal-body">
        <div class="leftColumn">
          <div class="sendEmailSmsWrapper" v-if="smsService || emailService">
            <div class="labelWrap">
              <p>SEND AS</p>
            </div>
            <div class="emailSmsMessageWrapper">
              <select name="emailSmsMessage" v-model="messageType">
                <option value="SMS" v-if="smsService">SMS</option>
                <option value="E-MAIL" v-if="emailService">E-MAIL</option>
              </select>
            </div>
          </div>
          <hash-codes-list
            templateType="checkin"
            :extendWidth="true"
          ></hash-codes-list>
        </div>
        <div class="rightColumn">
          <div class="smsWrapper extendHeight" v-if="messageType === 'SMS'">
            <div class="labelWrap">
              <p>TEMPLATE</p>
            </div>
            <textarea
              type="text"
              v-model="smsMessage"
              placeholder="Type your message here."
            />
          </div>
          <div class="sendEmailSmsWrapper" v-if="messageType === 'SMS'">
            <div class="labelWrap">
              <p>SMS INFORMATION:</p>
            </div>
            <div class="charInformation">
              <p>Characters: {{ messageLength }}</p>
              <p>Messages: {{ Math.ceil(messageLength / 160) }}</p>
            </div>
          </div>
          <div class="sendEmailSmsWrapper" v-if="messageType === 'E-MAIL'">
            <div class="labelWrap">
              <p>SUBJECT</p>
            </div>
            <div class="subjectInput">
              <input
                class="form-control"
                v-model="emailSubject"
                placeholder="Type your subject here."
              />
            </div>
          </div>
          <div
            class="emailWrapper extendHeight"
            v-if="messageType === 'E-MAIL'"
          >
            <div class="labelWrap hideElement">
              <p>TEMPLATE</p>
            </div>
            <div class="tinyEditor">
              <HtmlEditor
                v-model="emailMessage"
                api-key="o8eqr3asmep3tnky3mpofyp8062atqx826sxagxm6xq3a7c2"
                :init="{
                  selector: 'imgTest',
                  plugins: 'link lists hr code table',
                  branding: false,
                  menubar: false,
                  toolbar:
                    'formatselect forecolor bold italic fontsizeselect fontselect | bullist numlist alignleft aligncenter alignright alignjustify link hr removeformat code table imgBtn',
                  fontsize_formats: '8pt 11pt 10pt 12pt 14pt 18pt 24pt 36pt',
                  height: '100%',
                  resize: true,
                  setup: function (editor) {
                    editor.ui.registry.addButton('imgBtn', {
                      text: 'Image',
                      onAction: function () {
                        hideToolbar();
                        showImageModal = true;
                      },
                    });
                  },
                }"
              />
              <ImageManager
                v-if="showImageModal"
                :isModal="true"
                @changed="onSelectedImage"
                @close="(showImageModal = false), showToolbar()"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="sendButtonWrap">
        <button-global
          type="positive"
          text="SEND"
          @eventPassed="sendQuickmessage()"
        ></button-global>
      </div>
    </div>
    <success-modal
      title="YOUR MESSAGE HAS BEEN SENT"
      @successEventPassed="close"
      v-if="messageSuccessModal"
      :applyBackdrop="true"
    ></success-modal>
  </div>
</template>

<script>
import HashCodesList from "@/components/WIPComponents/HashCodesList";
import CloseIcon from "@/components/GlobalComponents/CloseIcon";
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import SuccessModal from "@/components/GlobalComponents/SuccessModal";
import ImageManager from "@/components/MediaPage/MediaImages";
import HtmlEditor from "@/components/GlobalComponents/HtmlEditor";
import bus from "@/bus.js";
import { db, firestore } from "@/firebase";
import returnUTCTimeMixin from "@/mixins/returnUTCTimeMixin";

export default {
  name: "QuickMessage",
  components: {
    HashCodesList,
    CloseIcon,
    ButtonGlobal,
    SuccessModal,
    ImageManager,
    HtmlEditor,
  },
  mixins: [returnUTCTimeMixin],
  props: {
    selectedRoom: Object,
  },
  data() {
    return {
      showImageModal: false,
      editorActive: false,
      messageSuccessModal: false,
      emailService: true,
      smsService: true,
      smsMessage: `Hi ##firstname##,

Visit your guestbook and find out what we have planned for you this evening!

See your guestbook here:

##link##`,
      emailSubject: "Exclusive offers today!",
      emailMessage:
        "<p>Hi ##firstname##,</p>\n<p>Visit your guestbook and find out what we have planned for you this evening!</p>\n<p>See your guestbook here:&nbsp;</p>\n<p>##link##</p>",
      messageType: "SMS",
    };
  },
  computed: {
    messageLength: function () {
      var messageCount = this.smsMessage.length;
      if (this.smsMessage.match(/##hotel##/g)) {
        messageCount = messageCount + this.$customerId.length - 9;
      }
      if (this.smsMessage.match(/##roomnumber##/g)) {
        messageCount = messageCount + 3 - 14;
      }
      if (this.smsMessage.match(/##link##/g)) {
        messageCount = messageCount + 56 + this.$hotelId.length - 8;
      }
      return messageCount;
    },
  },
  created() {
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        bus.$emit("closeQuickMessage");
      }
    });
  },
  destroyed: function () {
    document.removeEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        bus.$emit("closeQuickMessage");
      }
    });
  },
  methods: {
    sendQuickmessage() {
      const utcTimeStampConverted = this.returnUTCTime();
      const fullUTCYEAR = new Date(utcTimeStampConverted).getFullYear();
      const fullUTCMONTH = new Date(utcTimeStampConverted).getMonth() + 1;
      const formatedDate = new Date(utcTimeStampConverted).toISOString();

      var quickmessageDocRef = firestore
        .collection("Quickmessage")
        .doc(`${this.$hotelId}`)
        .collection(`${fullUTCYEAR}`)
        .doc(`${fullUTCMONTH}`)
        .collection("messages")
        .doc();

      firestore
        .collection("Quickmessage")
        .doc(`${this.$hotelId}`)
        .collection(`${fullUTCYEAR}`)
        .doc(`${fullUTCMONTH}`)
        .set(
          {
            lastActivity: utcTimeStampConverted,
          },
          { merge: true }
        );

      if (this.messageType === "SMS") {
        quickmessageDocRef.set({
          createdAt: formatedDate,
          messageContent: this.smsMessage,
          messageType: this.messageType,
          recipientRoom: this.selectedRoom.roomnumber,
        });
        const messageObj = {};
        messageObj.type = "QUICK-MESSAGE";
        messageObj.media = "sms";
        messageObj.guestname = this.selectedRoom.guestname
          ? this.selectedRoom.guestname
          : "No guest first name";
        messageObj.guestlastname = this.selectedRoom.guestlastname
          ? this.selectedRoom.guestlastname
          : "No guest last name";
        messageObj.roomnumber = this.selectedRoom.roomnumber;
        messageObj.guestID = this.selectedRoom.guestID;
        messageObj.receiverPhone = this.selectedRoom.phone;
        messageObj.message = this.smsMessage;
        messageObj.timestamp = utcTimeStampConverted;
        messageObj.docHash = quickmessageDocRef.id;
        messageObj.identification = `Room: ${this.selectedRoom.roomnumber} - ${messageObj.guestname}`;

        db.ref(`messages/${this.$customerId}/${this.$hotelId}/`)
          .push(messageObj)
          .then(() => (this.messageSuccessModal = true));
      } else if (this.messageType === "E-MAIL") {
        quickmessageDocRef.set({
          createdAt: formatedDate,
          messageContent: this.emailMessage,
          messageType: this.messageType,
          recipientRoom: this.selectedRoom.roomnumber,
        });

        const messageObj = {};

        messageObj.type = "QUICK-MESSAGE";
        messageObj.media = "email";
        messageObj.guestname = this.selectedRoom.guestname
          ? this.selectedRoom.guestname
          : "No guest first name";
        messageObj.guestlastname = this.selectedRoom.guestlastname
          ? this.selectedRoom.guestlastname
          : "No guest last name";
        messageObj.roomnumber = this.selectedRoom.roomnumber;
        messageObj.guestID = this.selectedRoom.guestID;
        messageObj.receiverEmail = this.selectedRoom.email;
        messageObj.emailSubject = this.emailSubject;
        messageObj.message = this.emailMessage;
        messageObj.timestamp = utcTimeStampConverted;
        messageObj.docHash = quickmessageDocRef.id;
        messageObj.identification = `Room: ${this.selectedRoom.roomnumber} - ${messageObj.guestname}`;

        db.ref(`messages/${this.$customerId}/${this.$hotelId}/`)
          .push(messageObj)
          .then(() => (this.messageSuccessModal = true));
      }
    },
    close() {
      bus.$emit("closeQuickMessage");
      this.messageSuccessModal = false;
    },
    onSelectedImage(imageUrl) {
      this.emailMessage += `<p><img class="responsive" style="display: block; margin-left: auto; margin-right: auto;" src="${imageUrl}" alt="second img"  /></p>`;
    },
    hideToolbar() {
      document.querySelector(".tox-toolbar__overflow").style.display = "none";
    },
    showToolbar() {
      document.querySelector(".tox-toolbar__overflow").style.display = "block";
    },
  }, //End of methods
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
p,
input,
textarea {
  color: #707070;
  font-size: 16px;
  margin: 0;
}

/* The Modal (background) */
.modal {
  position: fixed; /* Stay in place */
  z-index: 910; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgba(0, 0, 0, 0.8); /* Black w/ opacity */
}
.closeMessageModalWrapper {
  position: absolute;
  top: 0px;
  right: 5px;
}
/* Modal Content */
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  background-color: #fefefe;
  margin: auto;
  margin-top: 35px;
  padding: 25px;
  width: 90%;
  height: 90%;
  border: 1px solid #707070;
  border-radius: 15px;
}
h2.headerWrap {
  margin-top: 10px;
  margin-bottom: 40px;
  font-size: 32px;
  font-weight: 100;
}

.modal-body {
  width: 100%;
  height: 70%;
  position: relative;
  padding: 0px 25px 10px 25px;
  display: flex;
  overflow-y: scroll;
}

.leftColumn {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
.sendEmailSmsWrapper,
.smsWrapper {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.emailWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.labelWrap {
  margin-bottom: 15px;
}
.rightColumn {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.charInformation {
  display: flex;
}
.charInformation > p:nth-child(1) {
  margin-right: 15px;
}

.messagesInformatioNWrapper {
  margin-top: 40px;
  justify-content: center;
}
.smsCharInfoWrapper p {
  margin: 0;
}
div.emailSmsMessageWrapper > select {
  width: 250px;
  padding: 8px;
  border: 1px solid #707070;
  border-radius: 5px;
}

.subjectWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.labelWrap p {
  margin: 5px 0;
  font-weight: bold;
}
.subjectInput {
  width: 100%;
}
.form-control {
  padding: 15px 18px;
  width: 100%;
  color: #66615b;
  border-radius: 8px;
  border: 1px solid #707070;
  border-radius: 4px;
  outline: 0;
  -webkit-transition: 0.3s ease-in;
  transition: 0.3s ease-in;
}
.extendHeight {
  flex-grow: 1;
}
textarea {
  resize: none;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border: 1px solid #707070;
  border-radius: 5px;
  color: #66615b;
  font-size: 16px;
  padding: 18px;
}
.tinyEditor {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 1441px) {
  .modal-body {
    padding: 15px 15px 10px 15px;
  }
  .form-control {
    padding: 10px;
  }
  .labelWrap p {
    margin: 0;
    font-size: 14px;
  }
  .sendEmailSmsWrapper,
  .smsWrapper {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 769px) {
  .modal-body {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 25px 25px 10px 25px;
    display: flex;
    flex-direction: column;
  }
  .sendEmailSmsWrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .sendEmailSmsWrapper > .labelWrap {
    margin-bottom: 0px;
  }
  .hideElement {
    display: none;
  }
  .extendHeight {
    flex-grow: unset;
    height: 100%;
  }
  div.emailSmsMessageWrapper,
  .subjectInput {
    width: 50%;
  }
  div.emailSmsMessageWrapper > select {
    width: 100%;
  }
  .leftColumn {
    flex-grow: unset;
  }
  .rightColumn {
    margin-top: 10px;
    width: 100%;
    height: 100%;
  }
  .sendEmailSmsWrapper {
    margin-bottom: 5px;
  }
  .tinyEditor {
    width: 100%;
    height: 85%;
  }
}
</style>
